import React, { useEffect, useState } from 'react';
import './Bioinformatics.css';

const Bioinformatics = () => {
    const [cursorPos, setCursorPos] = useState({ x: -100, y: -100 });
    const [hovering, setHovering] = useState(false);
    const [isOverNavbar, setIsOverNavbar] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
        
        const moveCursor = (e) => {
            setCursorPos({ x: e.clientX, y: e.clientY });
            if (e.clientY < 120) {
                setIsOverNavbar(true);
            } else {
                setIsOverNavbar(false);
            }
        };
        
        window.addEventListener('mousemove', moveCursor);
        return () => window.removeEventListener('mousemove', moveCursor);
    }, []);

    const handleMouseEnter = () => setHovering(true);
    const handleMouseLeave = () => setHovering(false);

    return (
        <section className="aww-page">
            <div 
                className={`aww-cursor ${hovering ? 'hovering' : ''}`}
                style={{ 
                    left: `${cursorPos.x}px`, 
                    top: `${cursorPos.y}px`,
                    opacity: isOverNavbar ? 0 : 1 
                }}
            ></div>

            <div className="aww-hero">
                <div className="aww-hero-top" data-aos="fade-down" data-aos-duration="1500">
                    <div className="aww-hero-desc">
                        Bridge Your Passion for Life Sciences with the Future of Research. Step into computational biology through guided learning and global collaboration.
                    </div>
                </div>
                
                <h1 className="aww-huge-text" data-aos="fade-up" data-aos-duration="1500" data-aos-delay="200">
                    <span className="aww-outline-text" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>International</span><br/>
                    Bioinformatics<br/>
                    <span className="aww-outline-text" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>Programme</span>
                </h1>
            </div>

            <div className="aww-marquee-wrapper" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                <div className="aww-marquee">
                    {Array(4).fill().map((_, i) => (
                        <React.Fragment key={i}>
                            <span>CHEMBIOAI</span>
                            <span className="outline">FUTURE OF RESEARCH</span>
                            <span>LIFE SCIENCES</span>
                            <span className="outline">GLOBAL COLLABORATION</span>
                        </React.Fragment>
                    ))}
                </div>
            </div>

            <div className="aww-image-section">
                <div className="aww-image-text" data-aos="fade-right">
                    <h2><span className="aww-outline-text" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>About The</span><br/><span className="aww-outline-text" style={{color: 'var(--accent)', WebkitTextStroke: '1px transparent'}} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>Initiative</span></h2>
                    <p>
                        The International Bioinformatics Bridge Programme is designed to help international students take the next step into computational biology through guided learning, research exposure, and global collaboration.
                    </p>
                    <p>
                        Hosted by the ChemBioAI community, we provide an environment where curiosity meets absolute innovation.
                    </p>
                </div>
                <div className="aww-image-container"  >
                    <img src="/chembio1.png" alt="Bioinformatics Research" />
                    
                </div>
            </div>

            <div className="aww-list-section">
                <h2 className="aww-list-header aww-outline-text" data-aos="fade-up" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>Why Choose Us.</h2>
                
                <div className="aww-list-item" data-aos="fade-up" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <h3 className="aww-list-item-title"><span>01</span> Global Research</h3>
                    <div className="aww-list-item-desc">
                        Connect with like-minded students and researchers from diverse academic and cultural backgrounds globally.
                    </div>
                </div>
                
                <div className="aww-list-item" data-aos="fade-up" data-aos-delay="100" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <h3 className="aww-list-item-title"><span>02</span> Research Learning</h3>
                    <div className="aww-list-item-desc">
                        Develop analytical thinking through real-world scientific challenges and modern computational approaches.
                    </div>
                </div>
                
                <div className="aww-list-item" data-aos="fade-up" data-aos-delay="200" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <h3 className="aww-list-item-title"><span>03</span> Mentorship</h3>
                    <div className="aww-list-item-desc">
                        Learn in a highly supportive environment guided by experienced mentors and industry leaders.
                    </div>
                </div>

                <div className="aww-list-item" data-aos="fade-up" data-aos-delay="300" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <h3 className="aww-list-item-title"><span>04</span> Future-Ready</h3>
                    <div className="aww-list-item-desc">
                        Prepare yourself for research, higher education, and emerging careers in computational life sciences.
                    </div>
                </div>
            </div>

            <div className="aww-grid-section">
                <div className="aww-grid-box" data-aos="fade-in">
                    <h3 className="aww-outline-text" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>What You Expect</h3>
                    <div className="aww-tags" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        <div className="aww-tag">Computational Biology</div>
                        <div className="aww-tag">Collaborative Environments</div>
                        <div className="aww-tag">Industry Projects</div>
                        <div className="aww-tag">Scientific Problem-Solving</div>
                        <div className="aww-tag">Global Connections</div>
                        <div className="aww-tag">Professional Portfolio</div>
                    </div>
                </div>
                <div className="aww-grid-box" data-aos="fade-in">
                    <h3 className="aww-outline-text" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>Who Should Apply</h3>
                    <div className="aww-tags" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                        <div className="aww-tag">Undergraduates</div>
                        <div className="aww-tag">Master's Students</div>
                        <div className="aww-tag">Early-Career Researchers</div>
                        <div className="aww-tag">Biotechnology</div>
                        <div className="aww-tag">Genetics</div>
                        <div className="aww-tag">Pharmacy</div>
                    </div>
                </div>
            </div>

            <div className="aww-cta-section">
                <h2 className="aww-cta-title" data-aos="zoom-in" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    Start<br/>
                    <span className="aww-outline-text" style={{color: 'var(--accent)', WebkitTextStroke: '1px transparent'}}>Your Journey.</span>
                </h2>
                
                <a href="https://forms.gle/mYdR9CBFR5cBuhdF7" target="_blank" rel="noopener noreferrer" className="aww-btn" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
                    <span>Apply Now</span>
                    <i className="bi bi-arrow-right"></i>
                </a>
                
                <div className="aww-footer-links">
                    <a href="mailto:contact@chembioai.org" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>CONTACT@CHEMBIOAI.ORG</a>
                    <a href="tel:+918919820691" onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>+91 8919820691</a>
                </div>
            </div>

        </section>
    );
};

export default Bioinformatics;
